import { render } from "./vip-open.vue?vue&type=template&id=c195717e&scoped=true"
import script from "./vip-open.vue?vue&type=script&lang=js"
export * from "./vip-open.vue?vue&type=script&lang=js"

import "./vip-open.vue?vue&type=style&index=0&id=c195717e&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c195717e"]])

export default __exports__